module.exports = __webpack_public_path__ + "static/media/E7.e4d0237.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/E7.mp4
// module id = L2nX
// module chunks = 8